import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_QUICKSEARCH';

const en = {
    tooltip: 'Quick Search',
    placeholder: 'Search by',
    advancedSearch: 'Advanced Search',
    advancedSearchTooltip: 'Advanced Search (Query Generator)',
    noResults: "We couldn't find results for the value you were looking for.",
    searching: 'Searching....',
    closeandback: 'Close and back',
    typeMore: 'Type at least 3 characters to start your search',
    tryAdvancedSearch:
        'These are 20 results that match your search terms. \n Did not you find what you were looking for? Try the Advanced Search',
    help: 'The quick search lets you quickly scan the system for a document. It displays the 20 results that match your search term, and clicking a result opens it in a popup.\n\nWhen you open the search, you can see the fields thatare searched by the quick search.\n\nTo find more results for these search terms, or search using additionals terms, use the Advanced Search.'
};

const he = {
    tooltip: 'חיפוש מהיר',
    placeholder: 'חיפוש לפי',
    advancedSearch: 'חיפוש מתקדם',
    advancedSearchTooltip: 'חיפוש מתקדם (מחולל שאילתות)',
    noResults: '.לא הצלחנו למצוא תוצאות עבור הערך שחפשת',
    searching: 'רגע... מחפשים תוצאות עבורך',
    closeandback: 'סגירה וחזרה',
    typeMore: 'החיפוש יתחיל אחרי הקלדה של 3 תווים',
    tryAdvancedSearch: `מוצגות 20 תוצאות שעמדו בתנאי החיפוש. \n אם לא מצאת את התוצאות שחיפשת, כדאי להשתמש בחיפוש מתקדם`,
    help: 'החיפוש המהיר מאפשר לך לחפש תעודב בזריזות. החיפוש מציג את 20 התוצאות שתואמות את החיפוש שלך, ולחיצה על תעודה תפתח אותה בחלון נפרד.\n\nכשפותחים את החיפוש, מופיעים השדות שבהם מתבצע החיפוש.\n\nאם לא מצאת את התוצאות הרצויות, או שברצונך לבצע חיפושמורכב יותר עם תנאים נוספים, אפשר להשתמש בחיפוש המתקדם.'
};
const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'tooltip',
    2: 'noResults',
    3: 'placeholder',
    4: 'advancedSearch',
    5: 'advancedSearchTooltip',
    6: 'searching',
    7: 'closeandback',
    8: 'help',
    9: 'typeMore',
    10: 'tryAdvancedSearch'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
